import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

// Guard to restrict eVoucher access to account 276 only
const accessGuard = async (to, from, next) => {
  const accountId = to.params.accountId;
  
  // Only allow account 276 to access eVoucher
  if (accountId !== '276') {
    return next({ name: 'home', params: { accountId } });
  }
  
  await subscriptionGuard(to, from, next, store);
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/eVoucher'),
      name: 'eVoucher',
      component: Index,
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: accessGuard,
    }
  ],
};
